<div class="fz-dialog__close" mat-dialog-title>
  <button mat-icon-button (click)="handleClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="fz-dialog">
  <div class="fz-dialog__root">
    <div class="fz-dialog__head">
      <h2 class="fz-dialog__head__title mat-headline-small">
        Register a Credit Card
      </h2>
      <p class="fz-dialog__head__subtitle">
        Please enter your credit card information, ensuring that the name, and
        ZIP code match your profile information.
      </p>
    </div>
    <div class="fz-dialog__content">
      <ng-container *ngrxLet="data.error$ as error">
        <div class="fz-dialog__errors" *ngIf="error">
          <p class="error-alert mat-body-2">{{ error }}</p>
        </div>
      </ng-container>

      <ng-container *ngrxLet="data.submitting$ as submitting">
        <fz-credit-card-form
          [primaryActionName]="
            submitting === true ? 'Registering...' : 'Register Card'
          "
          [loading]="submitting === true"
          [disableSaveCard]="true"
          [disableSecondaryAction]="true"
          [initialData]="data.initialData"
          (submitCard)="onSubmitCard($event)"
        >
        </fz-credit-card-form>
      </ng-container>
    </div>
  </div>
</div>
